<div class="remediation-navigation-container">
  <div class="things-to-do-container">
    <div class="flex items-center back">
      <img
        src="https://cdn.catexpert.ab-inbev.com/assets/images/arrow-left.svg"
        class="pl-4 pr-4"
        (click)="onBack()"
      />
    </div>
    <div
      class="flex items-center nav-item"
      [class.active]="isActive('Home')"
      (click)="onSelect('Home')"
    >
      <p class="pl-4 pr-4 flex items-center">{{ 'SHARED.HOME' | translate }}</p>
    </div>

    <div
      class="flex items-center nav-item"
      [class.active]="isActive('Data')"
      (click)="onSelect('Data')"
    >
      <p class="pl-4 pr-4">{{ 'SHARED.DATA' | translate }}</p>
    </div>

    <div
      class="flex items-center nav-item"
      [class.active]="isActive('Review')"
      (click)="onSelect('Review')"
    >
      <p class="pl-4 pr-4">{{ 'SHARED.REVIEW' | translate }}</p>
    </div>
  </div>
  <div class="file-name-and-save-container">
    <div class="key-account">
      {{ keyAccountName }}
    </div>
    <ng-container *ngIf="fileName">
      <span class="separator">|</span>
      <div class="file-name">
        {{ fileName }}
      </div>
    </ng-container>
    <div class="flex items-center">
      <img
        src="https://cdn.catexpert.ab-inbev.com/assets/images/save.svg"
        class="pl-4 pr-4 cursor-pointer"
        (click)="onSave()"
      />
    </div>
  </div>
</div>
